module.exports = __webpack_public_path__ + "img/spider-web.924b7064.png";